import { render, staticRenderFns } from "./PopularPicks.vue?vue&type=template&id=7c86e326&scoped=true&"
import script from "./PopularPicks.vue?vue&type=script&lang=js&"
export * from "./PopularPicks.vue?vue&type=script&lang=js&"
import style0 from "./PopularPicks.vue?vue&type=style&index=0&id=7c86e326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86e326",
  null
  
)

export default component.exports